import {createAction} from '@reduxjs/toolkit';

import type {ProSubscription} from 'shared/models/checkout';
import {CompanyModel} from 'shared/models/company';
import type {Worker} from 'shared/models/worker';

export const profileActionTypes = {
  setWorker: createAction<Worker>('profile/setWorker'),
  setWorkerCompanies: createAction<CompanyModel[]>('profile/setWorkerCompanies'),
  updateCompany: createAction<CompanyModel>('profile/updateCompany'),
  setWorkerIsLoading: createAction<boolean>('profile/setWorkerIsLoading'),
  setWorkerResumeIsSaving: createAction<boolean>('profile/setWorkerResumeIsSaving'),
  setActiveCompany: createAction<string>('profile/setActiveCompany'),
  reset: createAction('profile/reset'),
  setCompanyProfileOpened: createAction<boolean>('profile/setCompanyProfileOpened'),
  setMyProfileOpened: createAction<boolean>('profile/setMyProfileOpened'),
  cancelSubscription: createAction<string>('profile/cancelSubscription'),
  updateSubscription: createAction<ProSubscription[]>('profile/updateSubscription'),
  setCreateNewCompany: createAction<boolean>('profile/setCreateNewCompany'),
  showCongratsPopup: createAction<boolean>('profile/showCongratsPopup'),
  showTutorialPopup: createAction<boolean>('profile/showTutorialPopup'),
  showAccessDeniedPopup: createAction<boolean>('profile/showAccessDeniedPopup'),
};

export type ProfileActions = typeof profileActionTypes;
